import { render, staticRenderFns } from "./ShopAssetSidebar.vue?vue&type=template&id=6444ecdd&scoped=true&"
import script from "./ShopAssetSidebar.vue?vue&type=script&lang=js&"
export * from "./ShopAssetSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ShopAssetSidebar.vue?vue&type=style&index=0&id=6444ecdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6444ecdd",
  null
  
)

export default component.exports